var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { PROGRESS_STEPS_ORDER } from '../constants/progress';
var INITIAL_PROGRESS = {
    add_group: true,
    provide_passwords: false,
    login_students: false,
    first_run: false,
};
var useGetStartedProgress = function (data) {
    var _a = useState(INITIAL_PROGRESS), progressSteps = _a[0], setProgressSteps = _a[1];
    var updateProgress = useCallback(function (step) {
        setProgressSteps(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[step] = true, _a)));
        });
    }, [setProgressSteps]);
    useEffect(function () {
        if (!data)
            return;
        setProgressSteps(function (prev) { return (__assign(__assign({}, prev), { provide_passwords: data.passwordsProvided, login_students: data.studentLogins, first_run: data.firstRunCompleted })); });
    }, [data]);
    return [progressSteps, updateProgress];
};
var useStepsAmount = function (progress) {
    return useMemo(function () { return ({
        completed: PROGRESS_STEPS_ORDER.filter(function (step) { return progress[step]; }).length,
        total: PROGRESS_STEPS_ORDER.length,
    }); }, [progress]);
};
var useProgressCompletion = function (progress, onCompleted) {
    var completed = useMemo(function () { return Object.values(progress).every(function (step) { return step; }); }, [progress]);
    var completedTriggered = useRef(false);
    useEffect(function () {
        if (completed && !completedTriggered.current) {
            completedTriggered.current = true;
            onCompleted();
        }
    }, [completed, onCompleted]);
    return completed;
};
export { useGetStartedProgress, useStepsAmount, useProgressCompletion };
